import React from 'react';
import classNames from 'classnames';

import NamedLink from '../NamedLink/NamedLink';

import css from './StatusTabs.module.css';

/**
 * A row of pill tabs that scrolls sideways on a phone, e.g. "All · 35", "To ship · 3".
 * Each tab is a link, so the chosen tab lives in the URL.
 */
const StatusTabs = props => {
  const { tabs, ariaLabel, className } = props;
  return (
    <nav className={classNames(css.root, className)} aria-label={ariaLabel}>
      {tabs.map(tab => (
        <NamedLink
          key={tab.key}
          name={tab.name}
          params={tab.params}
          to={tab.search ? { search: tab.search } : undefined}
          className={classNames(css.tab, { [css.selected]: tab.selected })}
        >
          {tab.label}
          {Number.isInteger(tab.count) ? <span className={css.count}>{tab.count}</span> : null}
        </NamedLink>
      ))}
    </nav>
  );
};

export default StatusTabs;
